import { Group, Stack } from "@mantine/core"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"

import { UpdateDisplaySettingButton } from "~/pages/Brand/OrganizationSettings/ProductPages/DisplaySettingsCrud/UpdateDisplaySettingButton.tsx"
import { AdvancedDisplaySettings } from "~/pages/Brand/OrganizationSettings/ProductPages/OutputCustomizationSettings/AdvancedDisplaySettings.tsx"
import { useOrganizationSettings } from "~/pages/Brand/OrganizationSettings/store/organization-settings-context"
import { publicAgecSearchPath } from "~/pages/Brand/Products/List/constants.ts"

interface Props {
  displaySetting: OrganizationsResponses.Organization["settings"]["displaySettings"][number]
  settings: Omit<
    OrganizationsResponses.Organization["settings"],
    "displaySettings"
  >
}
export const DisplaySettings = ({ displaySetting, settings }: Props) => {
  const searchEngineURL = `${document.location.origin}/${publicAgecSearchPath}/${displaySetting.slug}`
  const { organization } = useOrganizationSettings()

  return (
    <Stack gap="sm">
      <Group>
        <Stack gap="xs">
          {settings.outputCustomizationPlan === "ADVANCED" ? (
            <Group gap="sm">
              <AdvancedDisplaySettings displaySetting={displaySetting} />
              <UpdateDisplaySettingButton
                displaySetting={displaySetting}
                organizationSettingsId={settings.id}
                organizationId={organization.id}
              />
            </Group>
          ) : (
            <>
              <Group gap="sm">
                {displaySetting.agecProductPage &&
                  displaySetting.agecProductPageURL && (
                    <Group gap="sm">
                      <iframe
                        key={displaySetting.id}
                        src={displaySetting.agecProductPageURL}
                        width={350}
                        height={600}
                      />
                    </Group>
                  )}
                {displaySetting.searchEngine && (
                  <Group gap="sm">
                    <iframe
                      key={displaySetting.id}
                      src={searchEngineURL}
                      width={350}
                      height={600}
                    />
                  </Group>
                )}
              </Group>
            </>
          )}
        </Stack>
      </Group>
    </Stack>
  )
}
